export default {
  name: 'home',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    this.$router.push({ name: 'wizard' })
  },
  methods: {

  }
}
